import { render, staticRenderFns } from "./Rastreabilidade.vue?vue&type=template&id=058f616c&lang=pug"
import script from "./Rastreabilidade.vue?vue&type=script&lang=js"
export * from "./Rastreabilidade.vue?vue&type=script&lang=js"
import style0 from "./Rastreabilidade.vue?vue&type=style&index=0&id=058f616c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports